import React, { useState, useEffect } from 'react';
import Strapi from '../../services/strapi';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { ReadInternInterface } from '../../interfaces/article';
import { TextField, Button, Grid, Card, CardContent } from '@material-ui/core';
import qs from 'qs';

interface ReadInternProps {
	label?: string,
	hideDossier?: boolean,
	value: any[],
	onChange: (new_value: any[]) => void,
	mot_cle?: any[],
};

const article_to_readintern = (r: any[]): ReadInternInterface => {
	const get_articles_id = (type: string) => {
		return (r || [])
			.filter((e) => e.type === type || e.type === type + 's')
			.map((e) => e.data.id)
	}

	return {
		atlantico_lights: get_articles_id("atlantico-light"),
		decryptages: get_articles_id("decryptage"),
		dossiers: get_articles_id("dossier"),
		pepites: get_articles_id("pepite"),
		podcasts: get_articles_id("podcast"),
		rdvs: get_articles_id("rdv"),
		videos: get_articles_id("video")
	}
};

const readintern_to_article = (e: any[]): any[] => {
	if (e === undefined || e === null) {
		return [];
	}
	return e.map(e => ({type: e.type, data: {id: e.id, title: e.title}}));
}

const ArticlePicker = (props: ReadInternProps) => {
	const [options, setOptions] = useState<any[]>([]);
	const [inputValue, setInputValue] = useState<string>("");
	const [loading, setLoading] = useState(0);

	useEffect(() => {
		let active = true;
		const params: any = {
			_limit: 10,
			search: inputValue,
		};
		if (props.hideDossier) {
			params.type = ['decryptage', 'atlantico-light', 'podcast', 'pepite', 'video', 'rdv'];
		}
		setLoading((prev) => prev + 1);
		Strapi.get("all", params, {}).then((r) => {
			if (active) setOptions(r);
		}).finally(() => {
			setLoading((prev) => prev - 1);
		});
		return () => {
			active = false;
		}
	}, [inputValue, props.hideDossier]);

	return <Autocomplete
			multiple
			loading={!!loading}
			value={props.value}
			options={options}
			onInputChange={(_, newValue) => {
				setInputValue(newValue);
			}}
			renderInput={(params) => (
				<TextField {...params} fullWidth/>
			)}
			getOptionLabel={(option) => option.title || option.data.title || ""}
			onChange={(e, changedValue) => {
				if (props.onChange) {
					props.onChange(changedValue);
				}
			}}
	/>
};

const ReadIntern = (props: ReadInternProps) => {
	return <Grid item xs={12}>
		<Card>
			<CardContent>
				<Grid container justify="space-between">
					<Grid item>
						<h4>{props.label ?? "Lire aussi interne"}:</h4>
					</Grid>
					<Grid item>
						{props.mot_cle && <Button variant="contained" color="primary" onClick={() => {
							Strapi.get("all_admin?" + qs.stringify({
								mot_cle: props.mot_cle?.map(e => e.slug),
								_limit: 12/2
							})).then(r => {
								props.onChange(r)
							})
						}}>Remplir automatiquement</Button>}
					</Grid>
				</Grid>
				<ArticlePicker {...props}/>
			</CardContent>
		</Card>
	</Grid>
}

export default ReadIntern;

export { readintern_to_article, article_to_readintern, ArticlePicker };